import { Api } from '@/constants';

export const getSvg = (asset: string) => {
  return `${Api.EdupassApi}/contents/svg/${asset}`;
};
